import React from "react";
import type { KgLinksIconProps } from "./KgLinksIcon.types";

/** Network / links icon for ontology inspector Links tab. */
export const KgLinksIcon: React.FC<KgLinksIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <g clipPath="url(#kg-links-icon-clip)">
      <path
        d="M14.0001 10.668H11.3334C10.9652 10.668 10.6667 10.9664 10.6667 11.3346V14.0013C10.6667 14.3695 10.9652 14.668 11.3334 14.668H14.0001C14.3683 14.668 14.6667 14.3695 14.6667 14.0013V11.3346C14.6667 10.9664 14.3683 10.668 14.0001 10.668Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.66659 10.668H1.99992C1.63173 10.668 1.33325 10.9664 1.33325 11.3346V14.0013C1.33325 14.3695 1.63173 14.668 1.99992 14.668H4.66659C5.03478 14.668 5.33325 14.3695 5.33325 14.0013V11.3346C5.33325 10.9664 5.03478 10.668 4.66659 10.668Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.33333 1.33203H6.66667C6.29848 1.33203 6 1.63051 6 1.9987V4.66536C6 5.03355 6.29848 5.33203 6.66667 5.33203H9.33333C9.70152 5.33203 10 5.03355 10 4.66536V1.9987C10 1.63051 9.70152 1.33203 9.33333 1.33203Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33325 10.6667V8.66667C3.33325 8.48986 3.40349 8.32029 3.52851 8.19526C3.65354 8.07024 3.82311 8 3.99992 8H11.9999C12.1767 8 12.3463 8.07024 12.4713 8.19526C12.5963 8.32029 12.6666 8.48986 12.6666 8.66667V10.6667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8 7.9987V5.33203"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="kg-links-icon-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default KgLinksIcon;
